// extracted by mini-css-extract-plugin
export default {"container":"Articles_container__uNwY+","header":"Articles_header__QHWdH","row":"Articles_row__c7EAs","button":"Articles_button__deGM2"};